import React from 'react'
import { Typography, Box, FormControl, RadioGroup, FormControlLabel, Radio, FormHelperText } from '@mui/material'
import { MoveTimeStepProps } from '../types'

const MoveTimeStep: React.FC<MoveTimeStepProps> = ({ value, onChange, error }) => {
  const options = ['ASAP / This semester', 'Fall 2026', 'Spring 2027', 'Just browsing']

  return (
    <Box className="flex flex-col gap-6">
      <Typography variant="h5" className="font-bold text-gray-900">
        When are you looking to move or renew housing?
      </Typography>

      <FormControl error={error}>
        <RadioGroup value={value} onChange={e => onChange(e.target.value)} className="flex flex-col gap-2">
          {options.map(opt => (
            <FormControlLabel key={opt} value={opt} control={<Radio />} label={opt} className="text-base" />
          ))}
        </RadioGroup>
        {error && <FormHelperText>This question is required</FormHelperText>}
      </FormControl>
    </Box>
  )
}

export default MoveTimeStep
